import React from 'react';
import styles from './FooterDoc.module.scss';
import RoundedButton from '../../../../components/RoundedButton/RoundedButton';
import { Spin } from 'antd';
import cn from 'classnames';

const FooterDoc = ({ onCancel, onSubmit, isLoading }) => {
  return (
    <div className={styles.footer}>
      <RoundedButton
        text="Отменить"
        type="primary"
        onClick={onCancel}
        className={cn(styles.btn, styles.btnCancel)}
      />
      <RoundedButton
        text={isLoading ? <Spin /> : 'Сохранить'}
        type="primary"
        onClick={onSubmit}
        className={cn(styles.btn, styles.btnSave)}
        disabled={isLoading}
      />
    </div>
  );
};

export default FooterDoc;
